import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { brand, fonts, CALENDLY_URL, CONTACT_EMAIL, LINKEDIN_URL } from '../theme/brand';

const socials = [
  { label: 'LinkedIn', href: LINKEDIN_URL, Icon: LinkedInIcon },
  { label: 'X (formerly Twitter)', href: 'https://x.com/aithisjob', Icon: XIcon },
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61578594683830', Icon: FacebookIcon },
  { label: 'Instagram', href: 'https://www.instagram.com/aithisjob/', Icon: InstagramIcon },
];

const linkSx = {
  color: brand.textMuted,
  textDecoration: 'none',
  '&:hover': { color: brand.textStrong },
  '&:focus-visible': { outline: `2px solid ${brand.accent}`, outlineOffset: '3px' },
};

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ bgcolor: brand.ink, borderTop: '1px solid #262A33', fontFamily: fonts.body, color: brand.textMuted, fontSize: 14 }}>
      <Box sx={{ maxWidth: 1240, mx: 'auto', px: 3, py: 5, display: 'flex', flexWrap: 'wrap', gap: '24px 48px', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
          <Box sx={{ fontFamily: fonts.display, fontWeight: 800, fontSize: 18, color: brand.text }}>AI This Job</Box>
          <div>Software built right the first time.</div>
        </Box>

        <Box component="nav" aria-label="Footer" sx={{ display: 'flex', flexWrap: 'wrap', gap: '12px 24px', alignItems: 'center' }}>
          <Box component="a" href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" sx={linkSx}>Book a free call</Box>
          <Box component="a" href={`mailto:${CONTACT_EMAIL}`} sx={linkSx}>{CONTACT_EMAIL}</Box>
          <Box component={Link} to="/privacy" sx={linkSx}>Privacy</Box>
          <Box component={Link} to="/terms" sx={linkSx}>Terms</Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {socials.map(({ label, href, Icon }) => (
            <IconButton key={label} aria-label={label} href={href} target="_blank" rel="noopener noreferrer" sx={{ color: brand.textMuted, '&:hover': { color: brand.accent } }}>
              <Icon />
            </IconButton>
          ))}
        </Box>
      </Box>
      <Box sx={{ borderTop: '1px solid #262A33' }}>
        <Box sx={{ maxWidth: 1240, mx: 'auto', px: 3, py: 2.5, fontSize: 13 }}>
          © {year} AI This Job. All rights reserved.
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
